import { render, staticRenderFns } from "./JobDeatailsHeader.vue?vue&type=template&id=70e4b9d2&scoped=true&"
import script from "./JobDeatailsHeader.vue?vue&type=script&lang=ts&"
export * from "./JobDeatailsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./JobDeatailsHeader.vue?vue&type=style&index=0&id=70e4b9d2&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4b9d2",
  null
  
)

export default component.exports